// extracted by mini-css-extract-plugin
module.exports = {"serverUri":"style_serverUri__3wDJ5","filterBoxStandardWidth":"style_filterBoxStandardWidth__1R3zI"};